import axios from 'axios'
import { CMSApiResponseBody } from 'types/cms/request'
import { Language } from 'types/language'
import { CmsEncyclopediaArticle } from 'types/cms/collection-types'

/**
 * Get the encyclopedia articles from the CMS
 *
 * @param {'all' | Language} locale
 * @returns {Promise<CmsEncyclopediaArticle[]>}
 */
const getEncyclopediaArticles = async (locale: 'all' | Language = Language.DUTCH): Promise<CmsEncyclopediaArticle[]> => {
  try {
    const { data } = await axios.get<CMSApiResponseBody<CmsEncyclopediaArticle[]>>(
      `${process.env.CMS_API_URL}/encyclopedia-articles?locale=${locale}`
    )

    return data.data
  } catch (_) {
    return []
  }
}

export default getEncyclopediaArticles
